"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { COMMAND_PRIORITY_HIGH, KEY_ARROW_UP_COMMAND } from "lexical";
export default function EditLastDropArrowUpPlugin(t0) {
  const $ = _c(12);
  const {
    canEditLastDropWithArrow,
    onRequestEditLastDrop,
    canUseArrowUpShortcut
  } = t0;
  const [editor] = useLexicalComposerContext();
  const canEditLastDropWithArrowRef = useRef(canEditLastDropWithArrow);
  const onRequestEditLastDropRef = useRef(onRequestEditLastDrop);
  const canUseArrowUpShortcutRef = useRef(canUseArrowUpShortcut);
  let t1;
  let t2;
  if ($[0] !== canEditLastDropWithArrow) {
    t1 = () => {
      canEditLastDropWithArrowRef.current = canEditLastDropWithArrow;
    };
    t2 = [canEditLastDropWithArrow];
    $[0] = canEditLastDropWithArrow;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== onRequestEditLastDrop) {
    t3 = () => {
      onRequestEditLastDropRef.current = onRequestEditLastDrop;
    };
    t4 = [onRequestEditLastDrop];
    $[3] = onRequestEditLastDrop;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[6] !== canUseArrowUpShortcut) {
    t5 = () => {
      canUseArrowUpShortcutRef.current = canUseArrowUpShortcut;
    };
    t6 = [canUseArrowUpShortcut];
    $[6] = canUseArrowUpShortcut;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[9] !== editor) {
    t7 = () => editor.registerCommand(KEY_ARROW_UP_COMMAND, event => {
      if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) {
        return false;
      }
      if (!canEditLastDropWithArrowRef.current || !onRequestEditLastDropRef.current || !canUseArrowUpShortcutRef.current()) {
        return false;
      }
      const handled = onRequestEditLastDropRef.current();
      if (!handled) {
        return false;
      }
      event.preventDefault();
      return true;
    }, COMMAND_PRIORITY_HIGH);
    t8 = [editor];
    $[9] = editor;
    $[10] = t7;
    $[11] = t8;
  } else {
    t7 = $[10];
    t8 = $[11];
  }
  useEffect(t7, t8);
  return null;
}